export const styles = {
  color: "#414141",
  fontSize: "1.07142857em",
};
